import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { CLEAR_FORM } from '@control-front-end/common/constants/forms';
import CreateForm from './components/CreateForm';

function FormSelection(props) {
  const { data = {}, onContentChange } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_FORM });
    };
  }, []);

  // Обработчик callback
  const handleCallback = (funcName, dataObj = {}) => {
    if (props[funcName]) {
      props[funcName](dataObj);
    }
  };

  return (
    <CreateForm
      data={data}
      onClose={() => handleCallback('onClose')}
      onFormSave={(res) => handleCallback('onFormSave', res)}
      onContentChange={onContentChange}
    />
  );
}

FormSelection.propTypes = {
  data: PropTypes.object,
  onContentChange: PropTypes.func,
};

export default FormSelection;
